import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemProjectAssignSecurityRoute: InvariantJiraRoute = {
	name: 'global-settings-system-project-assign-security',
	path: '/secure/project/AssignIssueSecuritySchemeProgress.jspa',
};
